import React, { useEffect, useState } from "react";
import {
  askForNotificationPermission,
  subscribeToPush,
  checkSubscription,
} from "./../services/PushNotifications";
import { useDispatch } from "react-redux";
import { addNotification } from "../ReduxToolkit/Reducers/AppReducer";
import http from "../services/http";
import { setVendorData } from "../services/helper";

export default function NotificationHandler() {
  const [isSubscribed, setIsSubscribed] = useState(false);
  const dispatch = useDispatch();

  // Inside a React component
  useEffect(() => {
    const handleMessage = (event) => {
      console.log("Message from service worker:", event.data);
      // Dispatch an action to Redux
      dispatch(addNotification(event.data));
    };

    navigator.serviceWorker.addEventListener("message", handleMessage);

    return () => {
      navigator.serviceWorker.removeEventListener("message", handleMessage);
    };
  }, [dispatch]);

  useEffect(() => {
    const handleNotifications = async () => {
      try {
        if ("serviceWorker" in navigator) {
          const registration = await navigator.serviceWorker.ready;
          const subscription = await registration.pushManager.getSubscription();
          if (subscription) {
            // console.log("Already subscribed to notifications.", subscription);
            sendSubscriptionToServer(subscription);
            setIsSubscribed(true);
          } else {
            const permission = await Notification.requestPermission();
            if (permission === "granted") {
              const newSubscription = await subscribeToPush();
              console.log("New subscription:", newSubscription);
              setIsSubscribed(true);
              // Optionally send the subscription to the server here if not done inside subscribeToPush
              sendSubscriptionToServer(newSubscription);
            } else {
              console.error("Notification permission denied.");
            }
          }
        }
      } catch (error) {
        console.error("Error during notification setup:", error);
      }
    };

    handleNotifications();
  }, []);

  const sendSubscriptionToServer = async (subscription) => {
    try {
      const data = { notificationSubscription: subscription };
      const response = await http.saveVendorData(data);
      console.log("Subscription saved", response);

      // Update vendor data in localStorage using the helper function
      setVendorData(data);
    } catch (error) {
      console.error("Error saving Subscription:", error);
    }
  };

  return null; // This component does not render anything
}
